import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Badge,
  Progress,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import axios from "axios";
import swal from "sweetalert";
import { API_DONOR_DARAH, API_TIMEOUT } from "utils";
import { formatDate } from "utils/func";
import Header from "components/Header/Header";
import Footer_New from "components/Footer-New/Footer-New";
import LoginModal from "components/LoginModal/LoginModal";
import { useLoginModal } from "../contexts/LoginModalContext";

function PermintaanDonorPublik() {
  const { isOpen, toggleModal } = useLoginModal();
  const [permintaanList, setPermintaanList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedPermintaan, setSelectedPermintaan] = useState(null);
  const [formData, setFormData] = useState({
    nama: "",
    noHp: "",
    tanggal: "",
    kesiapan: "datang ke lokasi", // Default value
    catatan: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    fetchPermintaan();
  }, []);

  const fetchPermintaan = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_DONOR_DARAH}donationrequests`, {
        timeout: API_TIMEOUT,
      });

      if (response.data?.success && response.data.data) {
        // Filter hanya permintaan dengan namaPenerima "Bank Darah"
        const filtered = response.data.data.filter(
          (item) => item.namaPenerima === "Bank Darah"
        );
        setPermintaanList(filtered);
      }
    } catch (error) {
      console.error("Error fetching permintaan:", error);
      swal("Error", "Gagal mengambil data permintaan", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (permintaan) => {
    setSelectedPermintaan(permintaan);
    setFormData({
      nama: "",
      noHp: "",
      tanggal: "",
      kesiapan: "datang ke lokasi", // Default value
      catatan: "",
    });
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedPermintaan(null);
    setFormData({
      nama: "",
      noHp: "",
      tanggal: "",
      kesiapan: "datang ke lokasi", // Default value
      catatan: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.nama || !formData.noHp || !formData.tanggal) {
      swal("Info", "Nama, No. HP, dan Tanggal harus diisi", "error");
      return;
    }

    if (!selectedPermintaan) {
      swal("Error", "Data permintaan tidak ditemukan", "error");
      return;
    }

    setSubmitting(true);

    // Format tanggal untuk backend
    const tgl = new Date(formData.tanggal);
    const year = tgl.getFullYear();
    const month = String(tgl.getMonth() + 1).padStart(2, "0");
    const day = String(tgl.getDate()).padStart(2, "0");
    const date_string = `${year}-${month}-${day}`;

    // Gabungkan kesiapan dan catatan menjadi catatan
    let catatanFinal = "";
    if (formData.kesiapan) {
      catatanFinal += `Kesiapan: ${formData.kesiapan}`;
    }
    if (formData.catatan) {
      if (catatanFinal) catatanFinal += "\n";
      catatanFinal += `Catatan: ${formData.catatan}`;
    }

    const data = {
      requestID: selectedPermintaan.requestID,
      nama: formData.nama,
      noHp: formData.noHp,
      tanggal: date_string,
      catatan: catatanFinal,
      // pendonorID bisa null untuk user publik yang belum terdaftar
      pendonorID: null,
    };

    try {
      const response = await axios.post(
        `${API_DONOR_DARAH}responpendonor`,
        data,
        { timeout: API_TIMEOUT }
      );

      if (response.data?.success) {
        swal("Berhasil", "Response berhasil dikirim", "success").then(() => {
          handleCloseModal();
          fetchPermintaan(); // Refresh data
        });
      } else {
        swal(
          "Gagal",
          response.data?.message || "Response gagal dikirim",
          "error"
        );
      }
    } catch (error) {
      console.error("Error submitting response:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Response gagal dikirim";
      swal("Gagal", errorMessage, "error");
    } finally {
      setSubmitting(false);
    }
  };

  const calculateProgress = (item) => {
    const total = item.jumlahDibutuhkan || 0;
    const current = item.totalKantung || 0;
    const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
    return { percentage, current, total };
  };

  if (loading) {
    return (
      <>
        <Header />
        <div
          className="content"
          style={{
            margin: isMobile ? 10 : 20,
            background: "#ffffff",
            minHeight: "100vh",
            padding: isMobile ? "10px 0" : "20px 0",
            textAlign: "center",
          }}
        >
          <h4>Memuat data...</h4>
        </div>
        <Footer_New />
      </>
    );
  }

  return (
    <>
      <Header />
      <LoginModal isOpen={isOpen} toggle={toggleModal} />
      <div
        className="content"
        style={{
          margin: isMobile ? 10 : 20,
          background: "#ffffff",
          minHeight: "100vh",
          padding: isMobile ? "10px 0" : "20px 0",
        }}
      >
        <Row style={{ marginBottom: isMobile ? "30px" : "50px" }}>
          <Col xs="12">
            <Card
              style={{
                borderRadius: isMobile ? "15px" : "20px",
                boxShadow: "0 2px 20px rgba(0,0,0,0.08)",
                border: "none",
                overflow: "hidden",
              }}
            >
              <CardHeader
                style={{
                  background: "#ffffff",
                  borderBottom: "2px solid #f1f3f5",
                  padding: isMobile ? "20px 15px" : "30px",
                }}
              >
                <CardTitle
                  tag="h4"
                  style={{
                    color: "#2d3436",
                    margin: 0,
                    fontWeight: "400",
                    fontSize: isMobile ? "1.2rem" : "1.5rem",
                  }}
                >
                  🩸 Permintaan Donor Darah - Bank Darah RSUD Ba'a
                </CardTitle>
              </CardHeader>
              <CardBody
                style={{ padding: isMobile ? "20px 15px" : "40px 30px" }}
              >
                {permintaanList.length === 0 ? (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#636e72",
                      padding: "40px 20px",
                    }}
                  >
                    <p style={{ fontSize: "1.1rem", marginBottom: "10px" }}>
                      Tidak ada permintaan donor darah saat ini.
                    </p>
                    <p style={{ fontSize: "0.9rem", color: "#95a5a6" }}>
                      Silakan cek kembali nanti.
                    </p>
                  </div>
                ) : (
                  <Row>
                    {permintaanList.map((item, index) => {
                      const progress = calculateProgress(item);
                      return (
                        <Col
                          lg="6"
                          md="12"
                          key={item.requestID || index}
                          style={{ marginBottom: "25px" }}
                        >
                          <Card
                            style={{
                              border: "1px solid #e9ecef",
                              borderRadius: "16px",
                              padding: "25px",
                              height: "100%",
                              transition: "all 0.3s ease",
                              boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
                            }}
                            onMouseEnter={(e) => {
                              if (!isMobile) {
                                e.currentTarget.style.transform =
                                  "translateY(-5px)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 20px rgba(0,0,0,0.1)";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (!isMobile) {
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                                e.currentTarget.style.boxShadow =
                                  "0 2px 10px rgba(0,0,0,0.05)";
                              }
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                marginBottom: "15px",
                              }}
                            >
                              <div>
                                <h5
                                  style={{
                                    fontSize: "1.3rem",
                                    fontWeight: "500",
                                    color: "#2d3436",
                                    margin: 0,
                                    marginBottom: "5px",
                                  }}
                                >
                                  Golongan Darah: {item.golonganDarah}
                                </h5>
                                <p
                                  style={{
                                    fontSize: "0.9rem",
                                    color: "#636e72",
                                    margin: 0,
                                  }}
                                >
                                  {formatDate(item.tanggalPermintaan)}
                                </p>
                              </div>
                              <Badge
                                color={
                                  progress.percentage >= 100
                                    ? "success"
                                    : progress.percentage >= 50
                                    ? "warning"
                                    : "danger"
                                }
                                style={{
                                  fontSize: "0.85rem",
                                  padding: "6px 12px",
                                  borderRadius: "20px",
                                }}
                              >
                                {progress.percentage}% Terpenuhi
                              </Badge>
                            </div>

                            <div style={{ marginBottom: "20px" }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#636e72",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  Kebutuhan:
                                </span>
                                <strong style={{ color: "#2d3436" }}>
                                  {item.jumlahDibutuhkan} kantong
                                </strong>
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: "15px",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#636e72",
                                    fontSize: "0.9rem",
                                  }}
                                >
                                  Sudah Terpenuhi:
                                </span>
                                <strong style={{ color: "#2d3436" }}>
                                  {progress.current} kantong
                                </strong>
                              </div>
                              <Progress
                                value={progress.percentage}
                                color={
                                  progress.percentage >= 100
                                    ? "success"
                                    : progress.percentage >= 50
                                    ? "warning"
                                    : "danger"
                                }
                                style={{
                                  height: "10px",
                                  borderRadius: "10px",
                                  marginTop: "10px",
                                }}
                              />
                            </div>

                            <div style={{ marginBottom: "15px" }}>
                              <p
                                style={{
                                  fontSize: "0.9rem",
                                  color: "#636e72",
                                  margin: "5px 0",
                                }}
                              >
                                <strong>Lokasi:</strong>{" "}
                                {item.lokasiDonor || "-"}
                              </p>
                              <p
                                style={{
                                  fontSize: "0.9rem",
                                  color: "#636e72",
                                  margin: "5px 0",
                                }}
                              >
                                <strong>Jenis Pendonor:</strong>{" "}
                                {item.alasanDonor === "1" ||
                                item.alasanDonor
                                  ?.toLowerCase()
                                  .includes("pengganti")
                                  ? "Pendonor Pengganti (untuk permintaan pasien)"
                                  : item.alasanDonor === "2" ||
                                    item.alasanDonor
                                      ?.toLowerCase()
                                      .includes("sukarela")
                                  ? "Pendonor Sukarela (untuk permintaan bank darah)"
                                  : item.alasanDonor || "-"}
                              </p>
                            </div>

                            <Button
                              color="primary"
                              block
                              onClick={() => handleOpenModal(item)}
                              style={{
                                borderRadius: "10px",
                                padding: "12px",
                                fontSize: "1rem",
                                fontWeight: "500",
                              }}
                            >
                              Respon Permintaan
                            </Button>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>

        {/* Modal Form Response */}
        <Modal isOpen={modalOpen} toggle={handleCloseModal} size="md" centered>
          <ModalHeader toggle={handleCloseModal}>
            Form Response Permintaan Donor Darah
          </ModalHeader>
          <Form onSubmit={handleSubmit}>
            <ModalBody>
              {selectedPermintaan && (
                <div
                  style={{
                    padding: "15px",
                    background: "#f8f9fa",
                    borderRadius: "8px",
                    marginBottom: "20px",
                  }}
                >
                  <h6 style={{ marginBottom: "10px", color: "#2d3436" }}>
                    Detail Permintaan:
                  </h6>
                  <p
                    style={{
                      margin: "5px 0",
                      fontSize: "0.9rem",
                      color: "#636e72",
                    }}
                  >
                    <strong>Golongan Darah:</strong>{" "}
                    {selectedPermintaan.golonganDarah}
                  </p>
                  <p
                    style={{
                      margin: "5px 0",
                      fontSize: "0.9rem",
                      color: "#636e72",
                    }}
                  >
                    <strong>Kebutuhan:</strong>{" "}
                    {selectedPermintaan.jumlahDibutuhkan} kantong
                  </p>
                  <p
                    style={{
                      margin: "5px 0",
                      fontSize: "0.9rem",
                      color: "#636e72",
                    }}
                  >
                    <strong>Lokasi:</strong>{" "}
                    {selectedPermintaan.lokasiDonor || "-"}
                  </p>
                </div>
              )}

              <FormGroup>
                <Label>Nama Lengkap *</Label>
                <Input
                  type="text"
                  value={formData.nama}
                  onChange={(e) =>
                    setFormData({ ...formData, nama: e.target.value })
                  }
                  required
                  placeholder="Masukkan nama lengkap"
                />
              </FormGroup>

              <FormGroup>
                <Label>Nomor Handphone *</Label>
                <Input
                  type="text"
                  value={formData.noHp}
                  onChange={(e) =>
                    setFormData({ ...formData, noHp: e.target.value })
                  }
                  required
                  placeholder="Contoh: 081234567890"
                />
              </FormGroup>

              <FormGroup>
                <Label>Tanggal Donor *</Label>
                <Input
                  type="date"
                  value={formData.tanggal}
                  onChange={(e) =>
                    setFormData({ ...formData, tanggal: e.target.value })
                  }
                  required
                />
              </FormGroup>

              {/* Kesiapan default: "datang ke lokasi" - hidden input */}
              <Input type="hidden" value={formData.kesiapan} />

              <FormGroup>
                <Label>Catatan</Label>
                <Input
                  type="textarea"
                  rows="4"
                  value={formData.catatan}
                  onChange={(e) =>
                    setFormData({ ...formData, catatan: e.target.value })
                  }
                  placeholder="Masukkan catatan (opsional)"
                />
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button
                color="secondary"
                onClick={handleCloseModal}
                disabled={submitting}
              >
                Batal
              </Button>
              <Button color="primary" type="submit" disabled={submitting}>
                {submitting ? "Mengirim..." : "Kirim Response"}
              </Button>
            </ModalFooter>
          </Form>
        </Modal>
      </div>
      <Footer_New />
    </>
  );
}

export default PermintaanDonorPublik;
